import React from 'react';
import Typography from '@material-ui/core/Typography';

export default function Welcome() {

  return (
    <div>  
    <Typography variant="h6">
      Welcome
    </Typography>
    </div>
  );
}
